import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useDeleteCommentMutation,
  useGetPostDetailsWithCommentQuery,
} from "../../Data/services/postApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import Comment from "../Comment/comment";
import { Description, SubTitle } from "../CustomComponents";
import ImageWithPlaceholder from "../CustomComponents/ImageWithPlaceholder";
import ModalContainer from "../ModalContainer";
import CommentShimmer from "../Shimmers/comment_shimmer";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import cssStyles from "./styles/viewPostModal.module.scss";

const ViewPostModal = ({ handleViewModalClose, data }) => {
  const slug = data.slug;
  const [comments, setComments] = useState([]);

  const {
    data: postData,
    isSuccess,
    isLoading,
    refetch,
  } = useGetPostDetailsWithCommentQuery(slug);

  useEffect(() => {
    if (postData) {
      setComments(postData.data.post_comments);
    }
  }, [postData]);

  const [deleteComment, { isLoading: isDelete }] = useDeleteCommentMutation();

  const handleCommentDelete = async (slug) => {
    try {
      const { data } = await deleteComment(slug);

      if (data.code === 200) {
        await refetch();
        SuccessToast(data.message);
      }
    } catch (error) {
      Toast(error.message, "error");
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 black-text">View Post</p>
            <span
              className="bg-dark bg-opacity-75 d-flex p-3 rounded-5"
              role="button"
              onClick={handleViewModalClose}
              style={{ cursor: "pointer" }}
            >
              <FaCircleXmark />
            </span>
          </div>

          <Row className={`${cssStyles.contentRow} g-3`}>
            <Col md={6} xs={12} className={cssStyles.mediaCol}>
              <div className="d-flex flex-column w-100 gap-2">
                {data.post_images?.length > 0 ? (
                  data.post_images.map((image, index) => (
                    <ImageWithPlaceholder
                      key={image.slug || image.image_url || index}
                      src={image.image_url}
                      alt="post"
                      width="100%"
                      height={280}
                      className="rounded-3 w-100"
                      fallback="image"
                    />
                  ))
                ) : (
                  <ImageWithPlaceholder
                    src={data.video_thumbnail}
                    alt="post"
                    width="100%"
                    height={280}
                    className="rounded-3 w-100"
                    fallback="image"
                  />
                )}
              </div>
            </Col>

            <Col md={6} xs={12} className={cssStyles.detailsCol}>
              <div className="d-flex flex-column align-items-stretch w-100">
                <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                  <UserAvatarWithNameAndTag
                    avatarImage={data.user_image}
                    userName={data.user_name}
                  />
                </div>

                <Description
                  classes="mb-1 text-black-50"
                  text="Description"
                />

                <Description
                  classes="mb-0 black-text"
                  text={data.post_description}
                />

                <hr className={cssStyles.divider} />

                <SubTitle
                  classes="lc-1 fs-5 mb-3 black-text"
                  text="Comments"
                />

                {isLoading ? <CommentShimmer /> : null}

                {isSuccess ? (
                  comments.length > 0 ? (
                    comments.map((comment, i) => (
                      <React.Fragment key={comment.slug || i}>
                        <Comment
                          userName={`${comment.user.first_name} ${comment.user.last_name}`}
                          avatarImage={comment.user.image_url}
                          commentText={comment.comment}
                          commentSlug={comment.slug}
                          onCommentDelete={handleCommentDelete}
                          isDelete={isDelete}
                        />
                        {i < comments.length - 1 ? (
                          <hr className={cssStyles.divider} />
                        ) : null}
                      </React.Fragment>
                    ))
                  ) : (
                    <Description
                      classes="mb-0 black-text"
                      text="No Comment Found."
                    />
                  )
                ) : null}
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewPostModal;
